import { render, staticRenderFns } from "./ProgramMeta.vue?vue&type=template&id=5ed4cd46&scoped=true&"
import script from "./ProgramMeta.vue?vue&type=script&lang=ts&"
export * from "./ProgramMeta.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramMeta.vue?vue&type=style&index=0&id=5ed4cd46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed4cd46",
  null
  
)

export default component.exports